import { Button } from '../Button';
import { TextInput } from '../TextInput';
import { Text } from '../Text';
import { Form, FormSection, FormRow, FormField } from '../Form';
import { useValidatedState } from '../../hooks/validated-state';
import IntroCopy from '../../copy/careers/intro.md';

export const BasicsStep = (props) => {
  const [
    firstName,
    setFirstName,
    isFirstNameValid,
    shouldIndicateInvalidFirstName,
    setShouldIndicateInvalidFirstName,
  ] = useValidatedState('', /^.+$/);

  const [
    lastName,
    setLastName,
    isLastNameValid,
    shouldIndicateInvalidLastName,
    setShouldIndicateInvalidLastName,
  ] = useValidatedState('', /^.+$/);

  const [
    phoneNumber,
    setPhoneNumber,
    isPhoneNumberValid,
    shouldIndicateInvalidPhoneNumber,
    setShouldIndicateInvalidPhoneNumber,
  ] = useValidatedState(
    '',
    /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/,
  );

  const [
    emailAddress,
    setEmailAddress,
    isEmailAddressValid,
    shouldIndicateInvalidEmailAddress,
    setShouldIndicateInvalidEmailAddress,
  ] = useValidatedState(
    '',
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  );

  const [
    npn,
    setNpn,
    isNpnValid,
    shouldIndicateInvalidNpn,
    setShouldIndicateInvalidNpn,
  ] = useValidatedState('', /^[0-9]+$/);

  const validationStates = [
    isFirstNameValid,
    isLastNameValid,
    isPhoneNumberValid,
    isEmailAddressValid,
    isNpnValid,
  ];

  const makeAllValidationErrorsVisible = () => {
    setShouldIndicateInvalidFirstName(true);
    setShouldIndicateInvalidLastName(true);
    setShouldIndicateInvalidPhoneNumber(true);
    setShouldIndicateInvalidEmailAddress(true);
    setShouldIndicateInvalidNpn(true);
  };

  return (
    <Form
      onSubmit={() => {
        if (validationStates.some((isValid) => !isValid)) {
          makeAllValidationErrorsVisible();

          return;
        }

        props.onSubmit({
          firstName,
          lastName,
          phoneNumber,
          emailAddress,
          npn,
        });
      }}
    >
      <FormSection>
        <IntroCopy />
        <hr className="mt-4 mb-6" />
      </FormSection>
      <FormSection>
        <FormRow>
          <Text.H4>Express Your Interest</Text.H4>
        </FormRow>
        <FormRow>
          <FormField
            labelText="First Name"
            error={
              shouldIndicateInvalidFirstName
                ? 'Please enter your first name.'
                : ''
            }
          >
            <TextInput value={firstName} onChange={setFirstName} />
          </FormField>
          <FormField
            labelText="Last Name"
            error={
              shouldIndicateInvalidLastName
                ? 'Please enter your last name.'
                : ''
            }
          >
            <TextInput value={lastName} onChange={setLastName} />
          </FormField>
        </FormRow>
        <FormRow>
          <FormField
            labelText="Phone Number"
            error={
              shouldIndicateInvalidPhoneNumber
                ? 'Please enter a valid US phone number.'
                : ''
            }
          >
            <TextInput value={phoneNumber} onChange={setPhoneNumber} />
          </FormField>
          <FormField
            labelText="Email Address"
            error={
              shouldIndicateInvalidEmailAddress
                ? 'Please enter your email address.'
                : ''
            }
          >
            <TextInput value={emailAddress} onChange={setEmailAddress} />
          </FormField>
        </FormRow>
        <FormRow>
          <FormField
            labelText="NPN"
            error={shouldIndicateInvalidNpn ? 'Please enter a valid NPN.' : ''}
          >
            <TextInput value={npn} onChange={setNpn} />
          </FormField>
        </FormRow>
        <FormRow>
          <div className="flex w-full justify-end">
            <Button
              variant="PRIMARY"
              size="LARGE"
              type="submit"
              is="input"
              value="Submit"
            />
          </div>
        </FormRow>
      </FormSection>
    </Form>
  );
};
